import { Label, slot } from "@fluentui/react-components";
import type {
  AppIconPreviewGalleryButtonProps,
  AppIconPreviewGalleryButtonState,
} from "./AppIconPreviewGalleryButton.types";
// eslint-disable-next-line no-restricted-imports
import { AppGalleryButton } from "@1js/acui-gallery/lib/Next";
import * as React from "react";
import {
  previewIconStyles,
  textStylesForIcon,
} from "./useAppIconPreviewGalleryButtonStyles.styles";
import { mergeCssFromPropsandCustomDefined } from "@1js/acui-common";
import { AppIcon } from "@1js/acui-icons";

export const useAppIconPreviewGalleryButton = (
  props: AppIconPreviewGalleryButtonProps,
  ref: React.Ref<HTMLButtonElement>
): AppIconPreviewGalleryButtonState => {
  const iconStyles =
    props.previewIconProps && props.previewIconProps.styles
      ? mergeCssFromPropsandCustomDefined(
          props.previewIconProps.styles,
          previewIconStyles
        ).customDefinedCss
      : previewIconStyles;

  const buttonIcon = (
    <AppIcon
      {...props.previewIconProps}
      style={
        "root" in iconStyles
          ? (iconStyles.root as React.CSSProperties)
          : (iconStyles as React.CSSProperties)
      }
    />
  );

  const labelStyle = mergeCssFromPropsandCustomDefined(
    props.style?.label,
    textStylesForIcon
  );

  const buttonLabel = slot.optional(props.label, {
    defaultProps: {
      children: props.label,
      style: labelStyle.customDefinedCss as React.CSSProperties,
    },
    elementType: Label,
  });

  const root = slot.always(
    { ...props, ref },
    {
      defaultProps: {
        ...props,
        automationType: "AppIconPreview",
        uniqueId: props.id,
        ariaLabel: props.ariaLabel ?? props.label,
        shouldTakeFocus: props.shouldTakeFocus,
        icon: buttonIcon,
        ref,
      },
      elementType: AppGalleryButton,
    }
  );

  const state: AppIconPreviewGalleryButtonState = {
    ...props,
    components: {
      root: AppGalleryButton,
      buttonLabel: Label,
    },
    root,
    buttonLabel,
    styles: props.styles,
  };
  return state;
};
